
import answers from "../data/answers.json" with { type: 'json' };

import characterizations from "../data/characterizations.json" with { type: 'json' };

import questions from "../data/questions.json" with { type: 'json' };

import views from "../data/views.json" with { type: 'json' };

export const findAnswersByQuestionId = id => answers.filter( answer => answer.question_id === id );

export const findCharacterizationById = id => characterizations.find( characterization => characterization.id === id );

export const findQuestionById = id => questions.find( question => question.id === id );

export const findQuestionsByViewId = id => questions.filter( question => question.view_id === id );

export const findViewById = id => views.find( view => view.id === id );

export const validateAnswers = answers => {

  if ( !answers || ( Array.isArray( answers ) && !answers.length ) ) {

    return true;

  } 

  return false;

}
